// callStatsNetType = type = "bluetooth","cellular","ethernet","none","wifi","wimax","other","unknown"
// callStatsNetSpeed = effectiveType = A string that is either slow-2g, 2g, 3g, or 4g.

import reduxStore from "../../configureEnvStore";
import { CELLULAR_TYPE_ARRAY, NETWORK, NQ_UNSTABLE_PARAM } from "../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import Localize from "../../locale/Localize";
import { setIsNetworkUnstablePopupVisible, setLocalNetworkTypeTitle, setNetworkUnstableMessage } from "../../reducers/battery-network-info-reducer";
import { setCallParticipants, setIsMobileSessionInfoVisible } from "../../reducers/common-reducer";
import batteryInfoService from "../../services/batteryInfoService";
import { LogFirebase } from "../../services/firestore";
import { getParticipantIndex, sendDataTrack } from "../../shared/dataTrackFunction";

/**checks network type for the user */
export const checkNetworkType = (fromWhere) => {
    let callStatsNetSpeed = "N/A";
    let callStatsNetType = "Unknown";

    // if navigator connection available
    if (navigator.connection != undefined) {
        //desktop and safari don't have navigator.connection.type
        if (navigator.connection.type != undefined && navigator.connection.type != "none") {
            //android mWeb
            callStatsNetType = navigator.connection.type;
            callStatsNetSpeed = navigator.connection.effectiveType;
        } else if (navigator.connection.effectiveType != undefined && navigator.connection.effectiveType != "none") {
            //windows chrome
            callStatsNetSpeed = navigator.connection.effectiveType;
        }

        //if function called from change networkType then update local user details
        if (fromWhere == "onchange") {
            handleUpdateUserNetworkType(CALL_DATA.localIdentity, callStatsNetType, callStatsNetSpeed);
            sendNetworkInfoToAgent(callStatsNetType, callStatsNetSpeed);
        } else {
            //onload
            const localNetworkTypeStr = getNetworkTypeTitle(callStatsNetType, callStatsNetSpeed);
            reduxStore.dispatch(setLocalNetworkTypeTitle(localNetworkTypeStr));
        }
    }

    CALL_DATA.callstatsNetType = callStatsNetType;
    CALL_DATA.callstatsNetSpeed = callStatsNetSpeed;
};

/* gets network type string title to show on agent screen */
export const getNetworkTypeTitle = (netType, netSpeed) => {
    if (!netType) {
        return NETWORK.Unknown;
    }

    netType = netType.toUpperCase();

    if (netType === NETWORK.CELLULAR && netSpeed !== undefined) {
        return netSpeed.toUpperCase() + " Cellular";
    } else if (netType === NETWORK.WIFI || netType === "WI-FI") {
        return "Wi-Fi";
    } else if (netType === NETWORK.ETHERNET) {
        return "Wired Ethernet";
    } else if (CELLULAR_TYPE_ARRAY.includes(netType)) {
        return netType + " Cellular";
    } else {
        return NETWORK.Unknown;
    }
};

// Send guest network info to agent
export const sendNetworkInfoToAgent = (callStatsNetType, callStatsNetSpeed) => {
    const { isRemoteParticipantJoined } = reduxStore.getState().commonReducer;

    if (GLOBAL_MEETING_DATA.isGuest && isRemoteParticipantJoined) {
        const msg = {
            notification_type: NOTIFICATION_TYPES.NETWORK_INFO,
            username: CALL_DATA.participantUserName,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            networkType: callStatsNetType,
            networkSpeed: callStatsNetSpeed,
        };

        // updated firebase logs of net type
        LogFirebase("UpdateNetwork", "network_type", callStatsNetType);
        LogFirebase("UpdateNetwork", "network_speed", callStatsNetSpeed);

        sendDataTrack(msg);
    }
};

// Update networkType of user to redux callParticipants list
export const handleUpdateUserNetworkType = (identity, networkType, networkSpeed) => {
    const callParticipants = reduxStore.getState().commonReducer.callParticipants;

    const updatedParticipants = callParticipants.map((user) => {
        if (user.identity === identity) {
            const netType = getNetworkTypeTitle(networkType, networkSpeed);
            return { ...user, networkType: netType };
        }
        return user;
    });

    reduxStore.dispatch(setCallParticipants(updatedParticipants));
};

// handle Show Network Unstable View
export const handleShowNetworkUnstableView = (networkQuality, fromWhere) => {
    const { expandView, nqAvailable } = reduxStore.getState().commonReducer;
    const { streamingPartiIdentity, startLocalVideo } = reduxStore.getState().twilioEvents;

    let isNetworkUnstable = false;
    if (networkQuality && networkQuality < NQ_UNSTABLE_PARAM) {
        if ((GLOBAL_MEETING_DATA.isAgent || fromWhere == "local") && expandView && nqAvailable) {
            isNetworkUnstable = true;
            const participantIndex = getParticipantIndex(streamingPartiIdentity);
            const localizedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
            let networkUnstableMsg = "";

            if (startLocalVideo || fromWhere == "local") {
                networkUnstableMsg = localizedValues["your_internet_connection_is_unstable"];
            } else if (GLOBAL_MEETING_DATA.isAgent) {
                networkUnstableMsg = localizedValues["participants_connection_unstable"];
                networkUnstableMsg = networkUnstableMsg.replace("<participantNum>", participantIndex);
            }
            reduxStore.dispatch(setNetworkUnstableMessage(networkUnstableMsg));
        }
    } else if (PublicVariables.isMobile) {
        reduxStore.dispatch(setIsMobileSessionInfoVisible(true));
    }

    reduxStore.dispatch(setIsNetworkUnstablePopupVisible(isNetworkUnstable));
    batteryInfoService.isNetworkAndBatteryMessage();
};

// This function checks the online status of a user by making an API call.
// If the API responds with a status code between 200 and 299, it indicates the user is online, otherwise, it indicates offline.
export const checkOnlineStatus = async () => {
    try {
        const url = process.env.REACT_APP_BLITZZ_LOGO_URL;
        const online = await fetch(url, { method: "HEAD" });
        return online.status >= 200 && online.status < 300; // either true or false
    } catch (err) {
        return false; // definitely offline
    }
};
